var _path, _path2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g2, _path3, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 645,
    height: 376,
    viewBox: "0 0 645 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.635 319.163C327.201 319.163 333.866 391.208 405.22 371.918C476.574 352.628 567.228 279.795 480.27 129.739C393.344 -20.317 169.015 -23.4425 125.773 36.1315C97.5344 75.0582 154.769 114.869 113.138 156.479C71.507 198.089 -4.86958 256.937 60.3569 335.517C118.318 405.352 200.096 319.163 250.635 319.163Z",
    fill: "url(#bg_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M522.863 336.472H468.597C468.597 336.472 451.13 325.138 436.631 290.726C424.755 262.502 423.239 249.842 417.3 234.215C411.362 218.587 395 217.893 395 217.893C395 217.893 440.327 196.298 476.746 243.844C513.166 291.389 522.831 336.441 522.831 336.441L522.863 336.472Z",
    fill: "url(#paint1_linear_261_3254)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_261_3254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.591 36H154.409C151.422 36 149 38.4198 149 41.4047V175.595C149 178.58 151.422 181 154.409 181H347.591C350.578 181 353 178.58 353 175.595V41.4047C353 38.4198 350.578 36 347.591 36Z",
    fill: "white",
    fillOpacity: 0.48,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.591 36H154.409C151.422 36 149 38.4198 149 41.4047V175.595C149 178.58 151.422 181 154.409 181H347.591C350.578 181 353 178.58 353 175.595V41.4047C353 38.4198 350.578 36 347.591 36Z",
    stroke: "white",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 49,
    width: 187,
    height: 5,
    rx: 2.5,
    fill: "url(#paint2_linear_261_3254)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 75,
    width: 98,
    height: 5,
    rx: 2.5,
    fill: "url(#paint3_linear_261_3254)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 87,
    width: 148,
    height: 5,
    rx: 2.5,
    fill: "url(#paint4_linear_261_3254)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 150,
    width: 143,
    height: 5,
    rx: 2.5,
    fill: "url(#paint5_linear_261_3254)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 98,
    width: 113,
    height: 32,
    rx: 4,
    fill: "url(#paint6_linear_261_3254)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 137,
    width: 88,
    height: 5,
    rx: 2.5,
    fill: "url(#paint7_linear_261_3254)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 62,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "url(#paint8_linear_261_3254)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 163,
    width: 187,
    height: 5,
    rx: 2.5,
    fill: "url(#paint9_linear_261_3254)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_261_3254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.73 65H295.655C290.875 65 287 68.8729 287 73.6504V288.426C287 293.204 290.875 297.077 295.655 297.077H604.73C609.51 297.077 613.385 293.204 613.385 288.426V73.6504C613.385 68.8729 609.51 65 604.73 65Z",
    fill: "white",
    fillOpacity: 0.48,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.73 65H295.655C290.875 65 287 68.8729 287 73.6504V288.426C287 293.204 290.875 297.077 295.655 297.077H604.73C609.51 297.077 613.385 293.204 613.385 288.426V73.6504C613.385 68.8729 609.51 65 604.73 65Z",
    stroke: "white",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M392.774 223.206C388.163 226.246 386.851 232.489 390.361 236.753C401.523 250.314 416.288 260.554 433.047 266.231C452.976 272.982 474.587 272.896 494.461 265.987C514.336 259.077 531.34 245.739 542.783 228.081C554.226 210.423 559.455 189.455 557.644 168.491C555.832 147.528 547.083 127.767 532.781 112.334C518.478 96.9014 499.438 86.6776 478.673 83.2801C457.907 79.8826 436.602 83.5053 418.127 93.5751C402.59 102.043 389.8 114.664 381.131 129.939C378.404 134.742 380.768 140.667 385.832 142.871L410.862 153.767C415.925 155.971 421.74 153.566 424.958 149.077C429.083 143.324 434.472 138.534 440.763 135.105C450 130.07 460.653 128.259 471.036 129.958C481.418 131.657 490.938 136.768 498.089 144.485C505.241 152.201 509.615 162.082 510.521 172.563C511.427 183.045 508.812 193.53 503.091 202.358C497.369 211.187 488.867 217.856 478.93 221.311C468.993 224.766 458.187 224.809 448.223 221.433C441.437 219.135 435.306 215.34 430.255 210.38C426.315 206.51 420.174 205.138 415.564 208.178L392.774 223.206Z",
    fill: "url(#chart_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M380.339 145.806C377.232 144.652 373.759 146.232 372.805 149.405C369.361 160.864 368.117 172.89 369.159 184.847C370.2 196.803 373.506 208.433 378.88 219.123C380.368 222.084 384.062 223.039 386.922 221.366L417.392 203.545C420.252 201.872 421.175 198.207 419.878 195.158C417.931 190.584 416.712 185.719 416.278 180.741C415.845 175.763 416.204 170.761 417.33 165.919C418.081 162.691 416.538 159.242 413.431 158.089L380.339 145.806Z",
    fill: "#EBAE53"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_261_3254)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_261_3254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301 241H385V283C385 285.209 383.209 287 381 287H305C302.791 287 301 285.209 301 283V241Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5 241.5H384.5V283C384.5 284.933 382.933 286.5 381 286.5H305C303.067 286.5 301.5 284.933 301.5 283V241.5Z",
    stroke: "var(--chart-text)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.5 231C301.5 229.067 303.067 227.5 305 227.5H381C382.933 227.5 384.5 229.067 384.5 231V240.5H301.5V231Z",
    fill: "var(--chart-text)",
    fillOpacity: 0.8,
    stroke: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 233,
    width: 21,
    height: 4,
    rx: 2,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 247,
    width: 32,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 247,
    width: 13,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 256,
    width: 27,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 256,
    width: 13,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 265,
    width: 37,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 265,
    width: 13,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 274,
    width: 29,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 274,
    width: 13,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377.547 185L344.621 198.5V218.5",
    stroke: "#EBAE53",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_261_3254)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_261_3254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524 144H608V186C608 188.209 606.209 190 604 190H528C525.791 190 524 188.209 524 186V144Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.5 144.5H607.5V186C607.5 187.933 605.933 189.5 604 189.5H528C526.067 189.5 524.5 187.933 524.5 186V144.5Z",
    stroke: "var(--chart-text)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_261_3254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524 134C524 131.791 525.791 130 528 130H604C606.209 130 608 131.791 608 134V144H524V134Z",
    fill: "var(--chart-text)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.5 134C524.5 132.067 526.067 130.5 528 130.5H604C605.933 130.5 607.5 132.067 607.5 134V143.5H524.5V134Z",
    stroke: "var(--chart-text)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 556,
    y: 136,
    width: 21,
    height: 4,
    rx: 2,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 150,
    width: 32,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 150,
    width: 13,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 159,
    width: 27,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 159,
    width: 13,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 168,
    width: 37,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 168,
    width: 13,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 177,
    width: 29,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 177,
    width: 13,
    height: 4,
    rx: 2,
    fill: "var(--chart-text)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M524.5 111H562.652L571 124",
    stroke: "var(--chart-text-line)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M574 336H47V352H574V336Z",
    fill: "#EECCAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M516.198 336.472H570.464C570.464 336.472 587.931 325.138 602.43 290.726C614.306 262.502 615.822 249.842 621.761 234.215C627.699 218.587 644.061 217.893 644.061 217.893C644.061 217.893 598.734 196.298 562.315 243.844C525.895 291.389 516.23 336.441 516.23 336.441L516.198 336.472Z",
    fill: "url(#paint11_linear_261_3254)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5104 250.314C87.5104 250.314 98.1754 167.598 75.0847 126.215C51.9941 84.8324 6.46679 75.4408 1.73799 77.1986C-2.99082 78.9564 1.73799 135.707 18.2888 151.628C34.8396 167.548 60.2947 181.761 66.8345 208.329C73.3743 234.896 75.6884 250.264 75.6884 250.264H87.5104V250.314Z",
    fill: "url(#paint12_linear_261_3254)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3276 250.211C86.3276 250.211 63.8406 197.025 99.9606 157.45C136.081 117.875 159.725 120.838 159.725 120.838C159.725 120.838 139.602 158.656 120.083 202.399C100.564 246.143 86.3276 250.261 86.3276 250.261V250.211Z",
    fill: "url(#paint13_linear_261_3254)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M110.425 244.013H63.0252C60.2638 244.013 58.0252 246.251 58.0252 249.013V331.17C58.0252 333.932 60.2638 336.17 63.0252 336.17H110.425C113.186 336.17 115.425 333.932 115.425 331.17V249.013C115.425 246.251 113.186 244.013 110.425 244.013Z",
    fill: "var(--vase)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88 258.475C88 258.475 125.307 231.342 146.465 268.908C146.465 268.908 138.98 281.883 116.791 277.893C94.6009 273.903 88 258.475 88 258.475Z",
    fill: "url(#paint14_linear_261_3254)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M211.299 96.6558C187.547 90.981 169.689 101.089 165.534 108.922C161.379 116.754 167.183 131.473 178.616 142.409C190.05 153.345 176.172 161.089 171.251 155.089C166.33 149.089 162.145 126.064 152.273 135.345C142.401 144.626 145.761 155.591 164.238 168.626C182.714 181.66 142.696 158.99 139.16 168.626C135.624 178.261 149.209 194.96 165.181 198.359C165.181 198.359 168.923 218.428 195.445 216.093C221.966 213.758 236.789 193.926 212.36 187.394C187.93 180.862 190.789 177.227 195.975 175.66C201.162 174.094 233.665 174.094 233.43 162.36C233.194 150.626 205.877 160.793 204.05 156.892C202.222 152.99 237.113 153.109 238.94 142.409C240.767 131.71 244.038 104.488 211.299 96.6558Z",
    fill: "url(#leaf03_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.975 200.795C138.394 198.015 138.07 193.786 128.352 185.829C118.635 177.871 122.262 162.98 136.722 163.241C151.181 163.503 160.699 171.107 158.097 177.463C155.494 183.819 149.249 183.176 146.766 187.855C144.283 192.534 157.064 182.2 160.876 185.289C164.688 188.379 168.111 193.647 159.271 198.763C150.432 203.88 147.203 200.903 145.57 203.124C143.937 205.344 145.892 212.202 149.878 209.557C153.865 206.912 161.03 198.05 164.56 200.281C168.091 202.512 164.76 227.769 145.346 227.868C125.932 227.968 115.432 224.893 116.234 215.653C117.036 206.412 127.943 214.719 133.532 214.878C139.121 215.036 120.909 204.234 121.29 197.416C121.672 190.597 132.829 204.4 135.966 200.777L135.975 200.795Z",
    fill: "url(#paint16_linear_261_3254)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 120C215.5 120 152.5 178 145.899 293.013",
    stroke: "url(#paint17_linear_261_3254)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.926 164.383C108.121 162.373 105.351 156.669 113.926 139.91C122.501 123.152 105.527 106.216 83.8387 116.117C62.1499 126.019 53.604 142.186 62.4446 148.718C71.2851 155.25 80.2435 150.285 87.6107 154.718C94.9778 159.152 67.6605 154.186 64.2716 160.718C60.8828 167.25 59.763 176.353 77.0904 177.151C94.4179 177.949 97.0111 171.949 101.196 173.752C105.38 175.555 107.708 185.752 99.6338 184.954C91.5594 184.156 73.8784 177.388 70.2537 182.619C66.6291 187.851 91.1469 218.442 120.615 205.732C150.084 193.023 163.61 182.087 155.27 170.619C146.931 159.152 136.823 177.151 128.483 181.053C120.144 184.954 139.387 158.886 133.552 150.285C127.717 141.684 121.47 166.984 113.926 164.354V164.383Z",
    fill: "url(#paint18_linear_261_3254)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8387 135.507C83.8387 135.507 137.913 197.043 150.054 291.623",
    stroke: "#967F6E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.747 291.623C158.747 291.623 157.716 261.358 137.589 205.733",
    stroke: "#967F6E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.148 271.325C156.148 271.325 160.168 225.37 202.396 234.068C202.396 234.068 207.272 248.232 189.696 262.352C172.12 276.473 156.148 271.325 156.148 271.325Z",
    fill: "url(#paint19_linear_261_3254)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.114 238.745C155.114 238.745 178.573 220.996 192.516 244.693C192.516 244.693 187.9 253.056 173.705 250.779C159.509 248.503 155.114 238.745 155.114 238.745Z",
    fill: "#F1BEA7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M181.791 295.221C182.169 293.362 180.748 291.623 178.851 291.623H127.35C125.423 291.623 123.996 293.414 124.425 295.293L133.162 333.479C133.474 334.843 134.688 335.81 136.087 335.81H171.084C172.51 335.81 173.739 334.806 174.023 333.408L181.791 295.221Z",
    fill: "#688063"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M179.205 295.221C179.583 293.362 178.162 291.623 176.265 291.623H124.764C122.837 291.623 121.41 293.414 121.839 295.293L130.576 333.479C130.888 334.843 132.102 335.81 133.501 335.81H168.498C169.924 335.81 171.153 334.806 171.438 333.408L179.205 295.221Z",
    fill: "#688063"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_261_3254",
    x: 140.5,
    y: 27.5,
    width: 221,
    height: 163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_261_3254"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_261_3254",
    result: "effect2_dropShadow_261_3254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_261_3254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_261_3254",
    x: 278.5,
    y: 56.5,
    width: 343.385,
    height: 250.077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_261_3254"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_261_3254",
    result: "effect2_dropShadow_261_3254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_261_3254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_261_3254",
    x: 298,
    y: 225,
    width: 92,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_3254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_3254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_261_3254",
    x: 297,
    y: 237,
    width: 92,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_261_3254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_261_3254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_261_3254",
    x: 521,
    y: 128,
    width: 92,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_3254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_3254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_261_3254",
    x: 520,
    y: 140,
    width: 92,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_261_3254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_261_3254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_261_3254",
    x: 520,
    y: 126,
    width: 92,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_261_3254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_261_3254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg_linear",
    x1: 291.024,
    y1: 51.1699,
    x2: 275.458,
    y2: 375.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--bg-linear-01)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--bg-linear-02)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_3254",
    x1: 458.931,
    y1: 213,
    x2: 458.931,
    y2: 336.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#578835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B8956"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_261_3254",
    x1: 158,
    y1: 54,
    x2: 345,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_261_3254",
    x1: 158,
    y1: 80,
    x2: 256,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_261_3254",
    x1: 158,
    y1: 92,
    x2: 306,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_261_3254",
    x1: 158,
    y1: 155,
    x2: 301,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_261_3254",
    x1: 158,
    y1: 130,
    x2: 271,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_261_3254",
    x1: 158,
    y1: 142,
    x2: 246,
    y2: 142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#96F8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96F8D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_261_3254",
    x1: 158,
    y1: 67,
    x2: 208,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FFC2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_261_3254",
    x1: 158,
    y1: 168,
    x2: 345,
    y2: 168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_linear",
    x1: 434,
    y1: 96,
    x2: 447,
    y2: 261.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--chart-linear-01)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--chart-linear-02)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_261_3254",
    x1: 580.129,
    y1: 213,
    x2: 580.129,
    y2: 336.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68A231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DD568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_261_3254",
    x1: 4.5,
    y1: 77,
    x2: 84,
    y2: 246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.291526,
    stopColor: "#9AC51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#536912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_261_3254",
    x1: 153.5,
    y1: 121,
    x2: 91,
    y2: 243.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#9DB98A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#536746"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_261_3254",
    x1: 88,
    y1: 256,
    x2: 146,
    y2: 271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC61F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leaf03_linear",
    x1: 164.5,
    y1: 199,
    x2: 233.5,
    y2: 83.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--leaf03-linear-01)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--leaf03-linear-02)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_261_3254",
    x1: 122.951,
    y1: 167.992,
    x2: 152.733,
    y2: 226.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FDA47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_261_3254",
    x1: 146,
    y1: 293,
    x2: 220,
    y2: 126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.215986,
    stopColor: "#967F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782036,
    stopColor: "#D9C4B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_261_3254",
    x1: 96.5,
    y1: 102,
    x2: 122.5,
    y2: 202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#FFDA57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_261_3254",
    x1: 200,
    y1: 239,
    x2: 155,
    y2: 271.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1A18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#618F50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHome);
export default __webpack_public_path__ + "static/media/img-home.fcb40bb046bd1c9830e3ec101c671dd4.svg";
export { ForwardRef as ReactComponent };